export class DriverRankSettingEntity {
  id?: string
  isActive?: boolean
  acceptanceWeight?: number
  adherenceWeight?: number
  effectiveDaysWeight?: number
  dailyHoursWeight?: number
  productivityWeight?: number
  minorPenaltyScoreReduction?: number
  majorPenaltyScoreReduction?: number
  criticalPenaltyScoreReduction?: number
  dailyHoursBaseHours?: number
  dailyHoursBaseScore?: number
  dailyHoursExtraPerHourScore?: number
  dailyHoursMaxExtraScore?: number
  effectiveDayMinAdherenceThreshold?: number
  rankingWindowDays?: number
  productivityOrdersWeight?: number
  productivityUtilizationWeight?: number
  dailyProductivityMinOnlineMinutes?: number
  weeklyProductivityMinOnlineMinutes?: number
  productivityOrdersSmoothingAlpha?: number
  normalizationMinClamp?: number
  normalizationMaxClamp?: number
  minPartialDayOffRemainderMinutes?: number
  createdAt?: string
  updatedAt?: string
}
